import React from 'react';
import './style.scss';
import { CerebryLogoMobile, CerebryLogo } from '../images';
import Dropdown from '../Dropdown';

const Header = (props) => {
    return (
        <header className={['header__container']}>
            <div className={['header__container__logo']}>
                <span className={['logo__mobile']}>
                <CerebryLogoMobile/>
                </span>
                <span className={['logo__desktop']}>
                <CerebryLogo/>
                </span>
            </div>
            {
             props.cityList.length > 0 && 
            <Dropdown 
              selectCity = {props.selectCity}
              cityList={props.cityList} 
              selectedCity ={props.selectedCity}
            />
            }
        </header>
    )
}

export default Header;